import { mdiChartPie } from '@mdi/js'

export default {
  title: 'Dashboard',
  icon: mdiChartPie,
  resource: 'DashboardHeadMaster',
  action: 'read',
  to: 'dashboard-headmaster',
}
